/**
 * Inner-page intro band. Warm, restrained, type-led.
 */
const PageHero = ({ kicker, title, children }) => (
  <section className="page-hero grain">
    <div className="container page-hero__inner">
      {kicker && <span className="kicker reveal">{kicker}</span>}
      <h1 className="reveal" data-reveal="60">{title}</h1>
      {children && (
        <p className="lede page-hero__lede reveal" data-reveal="120">{children}</p>
      )}
    </div>
  </section>
);

export default PageHero;
